// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KtVxP","newExpiryDate":"styles_newExpiryDate__QgpN1","footer":"styles_footer__1XneF"};